export default __webpack_public_path__ + "static/DNGResidential_2-6b1237b46fffa9f73c5c6afa7ace72d8.jpg";